<template>
  <div class="property">
    <div class="main">
      <!-- Title -->
      <div class="title_bar">
        <div class="left">
          <div class="title">
            產權資料
          </div>
          <div class="tip">
            建置、編輯戶別產權資料。
          </div>
        </div>
      </div>

      <div class="temp-button-container">
        <el-button
          round
          @click="toHousekeeperHousehold"
        >
          住戶開通頁
        </el-button>
      </div>
      <!-- TODO: 希望之後能把 Housekeeper 住戶開通整併起來 -->
      <!-- TAB -->
      <!-- <el-tabs v-model="activeTabName" :before-leave="tabBeforeLeave">
          <el-tab-pane label="告警事件列表" name="baEvent">
            <Event
              ref="eventList"
              :asset-category-data-options="assetCategoryDataOptions"
              @handleClickReport="handleClickReport"
              @handleClickEditProperty="handleClickEditProperty"
              @closeEventReportAndDetailDialog="closeEventReportAndDetailDialog"/>
          </el-tab-pane>
          <el-tab-pane label="告警推播管理" name="baManagement">
            <Management
              :asset-category-data-options="assetCategoryDataOptions"
              @handleClickTagDetail="handleClickTagDetail"/>
          </el-tab-pane>
          <el-tab-pane label="歷史告警紀錄" name="baLog">
            <Log :asset-category-data-options="assetCategoryDataOptions" />
          </el-tab-pane>
          <el-tab-pane v-if="baExternalLink" label="中央監控系統" name="TAB4"></el-tab-pane>
        </el-tabs> -->

      <filter-frame
        ref="filter"
        :filter-form="propertyFilter"
        @search="search"
        @clear="clearSearch()"
        @change="handleFilterChange"
      />

      <div class="title_bar function">
        <div class="left">
          <div class="info">
            請點此
            <span @click="handleDownloadSample">下載空白範本</span>
            進行建檔
          </div>
        </div>
        <div class="right">
          <el-button
            icon="icon-upload2"
            round
            @click="$refs.fileInput.click()"
          >
            匯入
          </el-button>
          <input
            ref="fileInput"
            accept=".xlsx"
            style="display: none"
            type="file"
            @change="importExcel"
          >
          <el-button
            icon="icon-download"
            class="export"
            round
            @click="exportExcel"
          >
            匯出
          </el-button>
        </div>
      </div>
      <div class="title_bar function">
        <div class="left">
          {{ `社區總面積 ${communityArea} 平方公尺` }}
        </div>
      </div>

      <el-table
        :data="propertyListData"
        style="width: 100%"
      >
        <el-table-column
          label="#"
          type="index"
          width="50"
        />
        <el-table-column
          v-for="[key, value] of Object.entries(tableColObj) "
          :key="key"
          :prop="key"
          :label="value.label"
          :width="'auto'"
        >
          <template slot-scope="scope">
            <pre class="regular">{{ scope.row[key] }}</pre>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :width="80"
        >
          <template slot-scope="scope">
            <div class="operate">
              <el-button
                size="mini"
                @click="handleClickEditProperty(scope.row)"
              >
                編輯
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="isLoading" />
    </div>
    <PropertyEditDialog
      ref="propertyEditDialog"
      @propertyDetailUpdated="propertyDetailUpdated"
    />
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '../../components/FilterFrame'
import { propertyStructure } from './models/index'
import PropertyEditDialog from './components/PropertyEditDialog.vue'
import { housekeeperAPI } from '@/api/HousekeeperAPI.js'

const tableColObj = _cloneDeep(propertyStructure)
delete tableColObj.Id
delete tableColObj.OwnershipHolderPhone
delete tableColObj.Note
const defaultPropertyFilter = [
  {
    label: '棟別',
    name: 'building',
    type: 'select',
    options: [
      // {
      //   label: "",
      //   value: "",
      // },
    ],
    value: '',
    isDisable: true
  }
]
const propertyFilter = _cloneDeep(defaultPropertyFilter)
const isEditDialog = true
const { CommunityName } = JSON.parse(localStorage.getItem('loginUserInfo'))

export default {
  components: { FilterFrame, PropertyEditDialog, TableLoading },
  data () {
    const selectedBuilding = null
    const propertyListData = []
    const communityArea = 0
    const isLoading = true
    return { propertyFilter, tableColObj, propertyListData, isEditDialog, selectedBuilding, communityArea, isLoading }
  },
  async mounted () {
    this.getProperty()
    this.getBuilding()
  },
  destroyed () {},
  methods: {
    propertyDetailUpdated () {
      this.getProperty(this.selectedBuilding)
    },
    async getProperty (tag) {
      try {
        const res = await apiHousehold.getProperty(tag)
        this.communityArea = res.data.Data.CommunityArea
        this.propertyListData = res.data.Data.HouseholdPropertys
      // TODO: 測試用，完成檔案上傳功能再拔掉吧
      // this.handleClickEditProperty(this.propertyListData[0])
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    handleClickEditProperty (row) {
      this.$refs.propertyEditDialog.setSelectedProperty(row)
    },
    toHousekeeperHousehold () {
      window.location.href = `${window.location.origin}/community/comOpenServiceStatus.aspx`
    },
    async handleDownloadSample () {
      const res = await apiHousehold.getPropertySampleExcel()
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${CommunityName}_戶別建置匯入表單.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    importExcel (e) {
      const uploadFormData = new FormData()
      uploadFormData.append('File', e.target.files[0])
      apiHousehold.postPropertyExcel(uploadFormData)
        .then(res => {
          this.$refs.fileInput.value = ''
          this.$message.success('產權資料匯入成功')
          this.$refs.filter.onClear()
          this.getProperty()
        })
        .catch(err => {
          console.log(err)
        })
    },
    async exportExcel () {
      try {
        const res = await apiHousehold.getPropertyExcel({
          params: {
            Tag: this.selectedBuilding
          }
        })
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${CommunityName}_產權資料.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.log(error)
      }
    },
    clearSearch () {
      this.selectedBuilding = null
      this.getProperty(this.selectedBuilding)
    },
    search (selectedValue) {
      const selectedBuilding = selectedValue?.building
      this.selectedBuilding = selectedBuilding || null
      this.getProperty(this.selectedBuilding)
    },
    handleFilterChange (index, value, selectedValue) {
    },
    // 取得棟別
    /**
     * 取得棟別
     * @async
     * @returns {Promise<void>}
     */
    async getBuilding () {
      try {
        // 從 API 取得棟別資料
        const { data } = await housekeeperAPI.getCommunityTabletTag()
        this.propertyFilter[0].options = this.propertyFilter[0].options.concat(
          data.Data.Tags.map((item) => {
            return {
              label: item.Tag,
              value: item.Tag
            }
          })
        )
        this.propertyFilter[0].isDisable = false
      } catch (err) {
        // 取得棟別失敗，顯示警告訊息
        this.propertyFilter[0].isDisable = true
        this.$message({
          message: this.$t('Household.GetBuildingFailed'),
          type: 'warning'
        })
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.property {
  @include mainLayer();
  .main {
    display: flex;
    flex-direction: column;
    gap: 25px;
    .title_bar {
      margin: 0;
    }
    .function {
      display: flex;
      width: 100%;
      .left,
      .right {
        display: flex;
        flex: 0 0 50%;
        align-items: center;
        gap: 20px;
      }
      .right {
        justify-content: flex-end;
      }
    }
  }
  .temp-button-container {
    display: flex;
    justify-content: start;
  }
  ::v-deep .el-table {
    @include basicTable();
  }
  pre {
    white-space: pre-wrap; /* Since CSS 2.1 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
  }
}
</style>
